<template>
  <!-- 单行本收费详情页 -->
  <div>
    <Topadv v-if="keywords" :keys="keywords" :advId="647"></Topadv>
    <div class="main">
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span class="crumb" @click="$router.push({ path: '/read' })">阅读</span>
        <span>></span>
        <span style="color:#0091ff">单行本</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="left-introduce">
            <p class="tit">单行本介绍</p>
            <div class="introduce-cont">{{ infoList.description }}</div>
          </div>
          <div class="left-introduce">
            <p class="tit">免费试读</p>
            <div
              class="free-cont"
              v-for="(item, i) in tryReadList.articles"
              :key="i"
              @click="arctileDetail(item)"
            >
              <div class="img">
                <img :src="item.cover_url" alt />
              </div>
              <div class="content">
                <p>{{ item.title }}</p>
                <p>
                  {{ item.display_time | timefilters }} · 阅读时长{{
                    item.read_time
                  }}分钟 · {{ item.word_times }}字
                </p>
                <p>{{ item.visit_times }} 阅读</p>
              </div>
            </div>
          </div>
          <div class="left-introduce">
            <p class="tit">最新文章</p>
            <ul class="articleList">
              <li v-for="(item, i) in infoList.articles" :key="i">
                <h6>{{ item.title }}</h6>
                <div>{{ item.summary }}</div>
                <p>
                  {{ item.display_time | timefilters }} · 阅读时长{{
                    item.read_time
                  }}分钟 · {{ item.word_times }}
                </p>
              </li>
            </ul>
          </div>
          <div class="left-author">
            <p class="tit">作者介绍</p>
            <ul class="author-cont">
              <li v-for="(item, i) in infoList.authors" :key="i">
                <div>
                  <div class="img" @click="goAuthors(item)">
                    <img :src="item.avatar" alt />
                  </div>
                  <div class="name">{{ item.name }}</div>
                  <div class="personal">{{ item.introduction }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-r">
          <div class="right-box">
            <div class="wechart-box">
              <p class="title">本期封面</p>
              <div>
                <img :src="infoList.cover_url" alt />
              </div>
              <p>{{ infoList.name }}</p>
              <p class="arctileNum">{{ infoList.articles_count }}篇文章</p>
              <p class="arctileNum">
                {{ infoList.display_time | timefilters }} ·
                <span>单行本</span>
              </p>
              <ul>
                <li v-for="(item, i) in infoList.keywords" :key="i">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div class="right-box">
            <div class="wechart-box">
              <p>{{ infoList.price }}元 / 会员价{{ infoList.vip_price }}元</p>
              <p class="button">
                <el-button class="buy" @click="buy">购买单行本</el-button>
              </p>
              <p class="button" v-if="!token">
                <el-button @click="goLogin">已购买？登录</el-button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog">
      <!-- 单行本 -->
      <el-dialog
        :visible.sync="singleDialog"
        width="800px"
        :close-on-click-modal="false"
        class="singleDialog"
      >
        <div class="singleList">
          <div class="header">
            <div class="message">
              <div class="img">
                <img :src="info.avatar" alt />
              </div>
              <div>
                <p>{{ info.nickname }}</p>
                <p>
                  账号
                  <span>{{ info.login_name }}</span> ,
                  <template v-if="info.has_read_ability">您是Lite会员</template>
                  <template v-else>您还不是VIP会员</template>
                </p>
              </div>
            </div>
            <div class="close">
              <img src="@/assets/img/icon_close.png" @click="singleClose" alt />
            </div>
          </div>
          <div class="dialog-body">
            <h3>{{ infoList.name }}</h3>
            <div class="body-message">
              <div class="buy-box">
                <div class="img">
                  <img src="@/assets/img/icon_select.png" alt />
                </div>
                <p>{{ product_info.description }}</p>
                <div class="message">
                  ￥
                  <span>{{ product_info.price }}</span
                  >/永久
                </div>
              </div>
              <div class="buy-tips">
                <ul>
                  <li>· 购买单行本后即可永久阅读。</li>
                  <li>· Pro会员享受免费阅读全部单行本。</li>
                  <li>· Lite会员享受会员价购买单行本，普通用户原价购买 。</li>
                </ul>
                <p @click="goSubscribe">订阅会员？</p>
              </div>
            </div>
            <div class="pay-method">
              <div class="method">
                <el-button
                  :class="select == 0 ? 'selectBtn' : ''"
                  @click="changePay(0)"
                >
                  <div class="icon">
                    <img src="@/assets/img/icon_wechart.png" alt />
                    <span>微信支付</span>
                  </div>
                </el-button>
                <el-button
                  :class="select == 0 ? '' : 'isActive'"
                  @click="changePay(1)"
                >
                  <div class="icon">
                    <img src="@/assets/img/icon_alipay.png" alt />
                    <span>支付宝支付</span>
                  </div>
                </el-button>
              </div>
              <div class="pay-message">
                <div class="wechart">
                  <div
                    class="img"
                    v-show="!showRet && select == 1"
                    style="height: 153px;"
                  >
                    <iframe
                      style="width: 140px;margin-top: 10px;margin-left: 4px;border:none"
                      :src="wechat"
                    ></iframe>
                  </div>
                  <div class="img" v-show="!showRet && select == 0">
                    <canvas id="canvas"></canvas>
                  </div>
                  <div v-if="showBtn">
                    <p
                      @click="getWechat"
                      v-if="showRet"
                      style="cursor: pointer;margin-right:40px"
                    >
                      刷新二维码
                    </p>
                  </div>
                  <p v-else style="cursor: pointer;margin-right:40px">
                    {{ code_ts }}
                  </p>
                </div>
                <div class="pay">
                  <p>
                    {{ price_type[select] }}扫码，支付
                    <span>{{ product_info.price }}</span
                    >元
                  </p>
                  <p>支付账号：{{ info.login_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 弹框 -->
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
      @token="getToken"
    ></LoginDialog>
  </div>
</template>
<script>
import {
  getSubjectsList,
  getTryReadList,
  getProduct,
  getSubjectOrder,
  getNotifyJs
} from "@/api/read";
import LoginDialog from "@/components/loginDialog";
import QRCode from "qrcode";
import Topadv from "@/components/topadv";
import { getTdkList} from "@/api/tdk";

export default {
  components: {
    LoginDialog,
    Topadv
  },
  name: "read_detail",
  data() {
    return {
      tip: "刷新二维码",
      wechat: "",
      showRet: true,
      price_type: ["微信", "支付宝"],
      select: 0, // 默认微信支付 true
      product_info: {},
      type: "", //判断单行本，杂志，
      token: "", //是否登陆
      infoList: {},
      tryReadList: [],
      singleDialog: false,
      info: {
        avatar: require("@/assets/img/code.png"),
        nickname: "李晓雅",
        login_name: "187****2726",
        wechart: require("@/assets/img/code.png"),
        yicai_user_id: 0
      },
      isSelect: true, //默认微信支付 true
      pay: true, //默认微信支付 true 订阅会员
      isActive: 0,
      params: {
        id: "",
        page: "",
        per: ""
      },
      try: {
        id: "",
        page: "",
        per: ""
      },
      // 登陆弹窗
      loginDialogs: false,
      intervalId: null,
      // 倒计时
      numRefresh: 0,
      showBtn: true,
      code_ts: "请5秒后重试",
      sec: 10,
      keywords: null
    };
  },
  methods: {
    clearInt() {
      if (this.intervalId != null) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    getUserInfo() {
      if (
        localStorage.getItem("userInfo") != "" &&
        localStorage.getItem("userInfo") != null
      )
        this.info = JSON.parse(localStorage.getItem("userInfo"));
    },
    setWechat(src = "") {
      if (src != "") {
        if (this.select == 0) {
          var canvas = document.querySelector("canvas");
          QRCode.toCanvas(canvas, src);
        } else {
          this.wechat = src;
        }
        this.showRet = false;
      } else {
        this.tip = "刷新二维码";
        this.showRet = true;
      }
    },
    getWechat() {
      if (this.numRefresh > 0) {
        var timer = setInterval(() => {
          this.sec = this.sec - 1;
          this.code_ts = this.sec + "s后重试";
          this.showBtn = false;
          if (this.sec === 0) {
            clearInterval(timer);
            this.sec = 10;
            this.code_ts = this.sec + "s后重试";
            this.showBtn = true;
            this.showRet = true;
          }
        }, 1000);

        this.numRefresh = 0;
      } else {
        if (this.select == 0) {
          var channel = "wx_wap";
        } else {
          var channel = "alipay_wap";
        }
        var params = {
          channel: channel,
          uid: this.info.yicai_user_id,
          yicai_platform: "pc",
          putType: "1",
          quantity: 1,
          product_id: this.product_info.name,
          title: this.product_info.description,
          subject_id: this.params.id
        };
        getSubjectOrder(params).then(res => {
          if (res.data.hasOwnProperty("error")) {
            this.tip = "已购买";
          } else if (res.data.data.ret == 200) {
            this.setWechat(res.data.data.data.code_url);
            this.notify = res.data.data.data;
            this.getNotify(res.data.data.order_no);
          }
        });

        this.numRefresh++;
      }
    },
    getNotify(id) {
      let _this = this;
      this.intervalId = setInterval(function() {
        getNotifyJs(id).then(res => {
          if (res.data.data.status == "paid") {
            _this.$message.success("支付成功");
            setTimeout(function() {
              _this.clearInt();
              // location.reload();

              _this.$router.push({
                name: "read_free",
                params: {
                  id: _this.infoList.id,
                  type: "Subject",
                  is_jurisdiction: true,
                  cover: _this.infoList.cover_url,
                  title: _this.infoList.name,
                  time: _this.infoList.display_time
                }
              });
            }, 1000);
          }
        });
      }, 5000);
    },
    getProduct() {
      var params = {
        type: "android",
        subject_id: this.params.id
      };
      getProduct(params).then(res => {
        this.product_info = res.data.data[0];
      });
    },
    // 获取列表
    getList(params) {
      getSubjectsList(params).then(res => {
        this.infoList = res.data.data;
        try {
          console.log('aaaa')
          let defaultParams = [
          ["ptype", "list"],
          ["pchannel", "webpc"],
          ["aaction", "pageview"],
          ["acategory", this.type.toLowerCase()],
          ["acname", "单行本"],
          ["acategory2", this.type.toLowerCase() + this.params.id],
          ["ac2name", res.data.data.name],
          ["aid", this.params.id]
        ];
        this.$ba(defaultParams);

        } catch (error) {
          console.log(error)
        }

      });
    },
    buy() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        this.singleDialog = true;
        this.getProduct();
      }
    },
    singleClose() {
      this.singleDialog = false;
      this.pay = true;
    },
    // 切换支付方式
    payMethod(tag) {
      if (tag == 1) {
        this.isSelect = true; //微信支付
      } else {
        this.isSelect = false; //支付宝支付
      }
    },
    //会员订阅切换支付方式
    changePay(tag) {
      this.select = tag;
      this.setWechat();
    },
    // 会员订阅
    goSubscribe() {
      this.singleDialog = false;
      this.resetSetItem("isActive", 0);
      this.pay = true;
      this.$router.push({
        name: "member"
      });
    },
    // 文章详情页
    arctileDetail(scope) {
      this.$router.push({
        name: "article_detail",
        params: {
          id: scope.id,
          isRead: true,
          titleType: "单行本",
          readType: "charge",
          readId: this.id,
          readTypes: this.type
        }
      });
    },
    goAuthors(item) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "author_detail",
        params: { id: item.id }
      });
    },
    // 登陆
    goLogin() {
      this.loginDialogs = true;
    },
    // 弹框
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    getToken(data) {
      this.token = data;
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    
    this.params.id = this.$route.params.id;
    this.keywords = this.params.id;
    this.try.id = this.$route.params.id;
    this.type = this.$route.params.type;

    this.getList(this.params);
    getTryReadList(this.try).then(res => {
      this.tryReadList = res.data.data;
    });
    this.token = localStorage.getItem("Authorization");
    this.getUserInfo();
  },
  destroyed() {
    this.clearInt();
  }
};
</script>
<style lang="scss" scoped>
.content-l {
  margin-bottom: 30px;
}
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}
.left-introduce {
  background: #ffffff;
  padding: 20px 30px 20px 30px;
  font-size: 16px;
  margin-bottom: 30px;
  .tit {
    font-weight: 600;
  }
  .introduce-cont {
    margin-top: 16px;
    font-size: 18px;
  }
  .free-cont {
    margin-top: 16px;
    display: flex;
    cursor: pointer;
    .img {
      margin-right: 20px;
      width: 250px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .content {
      position: relative;
      p {
        font-size: 14px;
        color: #999999;
      }
      p:first-child {
        font-size: 20px;
        // margin-top: 6px;
        line-height: 40px;
        color: #333;
      }
      p:last-child {
        position: absolute;
        bottom: 4%;
      }
    }
  }
  .articleList {
    margin-top: 16px;
    li {
      margin-bottom: 10px;
    }
    h6 {
      font-weight: 500;
      font-size: 20px;
      margin-bottom: 10px;
    }
    div {
      font-size: 14px;
      color: #999999;
      line-height: 24px;
    }
    p {
      font-size: 14px;
      color: #999999;
      line-height: 40px;
    }
  }
}
.left-author {
  background: #ffffff;
  padding: 20px 30px 0px 30px;
  font-size: 16px;
  margin-bottom: 30px;
  .tit {
    font-weight: 600;
  }
  .author-cont {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    flex-wrap: wrap;
    li {
      width: 30%;
      text-align: center;
      margin-bottom: 30px;
      div {
        .img {
          height: 78px;
          width: 78px;
          display: inline-block;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        .name {
          font-size: 18px;
          color: #333333;
          margin-top: 7px;
          margin-bottom: 11px;
        }
        .personal {
          text-align: center;
          font-size: 16px;
          color: #666666;
          line-height: 24px;
          // text-align: justify;
        }
      }
    }
  }
  .author-cont:after {
    content: "";
    width: 30%;
  }
}
.right-box {
  background: #fff;
  text-align: center;
  font-size: 16px;
  .wechart-box {
    padding: 30px;
    border-bottom: 1px solid #f5f5f5;
    p {
      line-height: 24px;
    }
    .title {
      font-weight: 600;
    }
    .button {
      padding: 0 30px;
      .el-button {
        width: 100%;
        border-radius: 23px;
        border: 1px solid;
        color: #0091ff;
        margin-top: 10px;
        margin-bottom: 6px;
      }
      .el-button:hover,
      .el-button:focus {
        background: #ffffff;
      }
      .buy {
        background: #0091ff;
        color: #ffffff;
      }
      .buy:hover,
      .buy:focus {
        background: #0091ff;
        color: #ffffff;
      }
    }
    div {
      max-width: 200px;
      padding: 20px 30px 10px 30px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .arctileNum {
      font-size: 14px;
      color: #999999;
      span {
        color: #0091ff;
      }
    }
    ul {
      display: flex;
      // justify-content: center;
      margin-top: 10px;
      flex-wrap: wrap;
      margin-bottom: -10px;
      li {
        padding: 2px 12px;
        border-radius: 23px;
        border: 1px solid #999999;
        margin-right: 9px;
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }
}
.singleDialog {
  >>> .el-dialog__header {
    display: none;
  }
  >>> .el-dialog__body {
    padding: 0;
    margin-top: 5px;
  }
  .singleList {
    .header {
      display: flex;
      justify-content: space-between;
      background: url("../../assets/img/bg_single.png") no-repeat;
      padding: 20px 20px 20px 30px;
      background-size: auto;
      .message {
        display: flex;
        .img {
          width: 70px;
          height: 70px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        div {
          p {
            font-size: 20px;
            color: #9a6416;
            margin-top: 6px;
          }
          p:last-child {
            font-size: 14px;
            span {
              color: #ff0000;
            }
          }
        }
      }
    }
    .dialog-body {
      padding: 6px 30px 30px 30px;
      h3 {
        color: #dfb349;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 40px;
        span {
          vertical-align: middle;
          display: inline-block;
        }
        img {
          vertical-align: middle;
          display: inline-block;
        }
      }
      .body-message {
        display: flex;
        .buy-box {
          width: 28%;
          border: 2px solid #dfb349;
          text-align: center;
          position: relative;
          margin-right: 30px;
          padding: 10px;
          font-size: 16px;
          background: #fcf7e6;
          .img {
            display: inline-block;
            img {
              position: absolute;
              left: 10px;
              top: 10px;
            }
          }
          p {
            line-height: 36px;
          }
          .message {
            color: #dfb349;
            font-size: 18px;
            margin-bottom: 10px;
            span {
              font-size: 30px;
              font-weight: 600;
              margin-left: -9px;
            }
          }
        }
        .buy-tips {
          font-size: 14px;
          ul {
            li {
              margin-bottom: 20px;
            }
          }
          p {
            padding-bottom: 10px;
            text-decoration: underline;
            color: #0091ff;
            cursor: pointer;
          }
        }
        .subsrcibe {
          display: flex;
          width: 100%;
          justify-content: space-between;
          li {
            width: 30.5%;
            border: 1px solid #eeeeee;
            position: relative;
            cursor: pointer;
            .subsrcibe-box {
              width: 100%;
              text-align: center;
              padding: 10px;
              font-size: 16px;
              .img {
                img {
                  position: absolute;
                  left: 10px;
                  top: 10px;
                }
              }
              .limited {
                position: absolute;
                background: #ff0000;
                padding: 5px 12px;
                border-radius: 0 10px 0 10px;
                right: -2px;
                top: -17px;
                color: #fff;
                font-size: 14px;
              }
              p {
                line-height: 36px;
                margin-top: 20px;
              }
              .message {
                color: #dfb349;
                font-size: 18px;
                margin-bottom: 10px;
                span {
                  font-size: 30px;
                  font-weight: 600;
                  margin-left: -9px;
                }
              }
            }
          }
          .showIcon {
            border: 2px solid #dfb349;
            background: #fcf7e6;
          }
        }
      }
      .pay-method {
        border: 1px solid #eeeeee;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .method {
          display: flex;
          flex-direction: column;
          margin-right: 40px;
          .el-button {
            border: 1px solid #eeeeee;
            background: #f5f5f5;
            text-align: center;
            line-height: 100px;
            border: none;
            margin-left: 0;
            border-radius: 0;
            font-size: 16px;
            padding: 0 40px;
            .icon {
              img {
                vertical-align: middle;
                margin-right: 4px;
              }
            }
          }
          .selectBtn {
            background: #fff;
            border-right: 0;
          }
          .isActive {
            background: #fff;
            border-right: 0;
          }
          >>> .el-button:hover,
          .el-button:active,
          .el-button:focus {
            color: #333 !important;
          }
        }
        .pay-message {
          display: flex;
          align-items: center;
          margin-right: 16px;
          .wechart {
            text-align: center;
            color: #999999;
            margin-right: 30px;
            .img {
              padding: 10px;
              border: 1px solid #eeeeee;
              margin-bottom: 6px;
              img {
                width: 100%;
                object-fit: cover;
              }
              >>> #canvas {
                width: 136px;
                height: 136px;
              }
            }
          }
          .pay {
            font-size: 16px;
            p {
              line-height: 38px;
              span {
                color: #dfb349;
                font-size: 30px;
                font-weight: bold;
              }
            }
            p:last-child {
              color: #999999;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/read/detail.vue